module.exports = __webpack_public_path__ + "static/media/12.360e8fae.png";